
import SafeImage from "../../components/common/SafeImage";

export default  function  Detail() {
    const stock = {
        name: "Everett C. Green",
        company: "Essex Court",
        phone: "+802-370-2430",
        email: "EverettCGreen@rhyta.com",
        image: "https://randomuser.me/api/portraits/men/32.jpg",
    };

    // Example stock details data
    const stockDetails = [
        {
            batchNo: "BCH12345",
            ignoreExpiry: false,
            qty: 100,
            mfDate: "2024-01-15",
            expDate: "2025-01-15",
        },
        {
            batchNo: "BCH67890",
            ignoreExpiry: true,
            qty: 50,
            mfDate: "2023-11-10",
            expDate: "2024-11-10",
        },
    ];

    return (
        <>
            {/* stock Info Card Start */}
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="title-header title-header-block package-card">
                                    <div>
                                        <h5>stock: {stock.name}</h5>
                                    </div>
                                    <div className="card-order-section">
                                        <ul>
                                            <li>Company: {stock.company}</li>
                                            <li>Phone: {stock.phone}</li>
                                            <li>Email: {stock.email}</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="bg-inner cart-section order-details-table">
                                    <div className="row g-4">
                                        <div className="col-xl-8">
                                            <div className="table-responsive table-details">
                                                <table className="table cart-table table-borderless">
                                                    <thead>
                                                        <tr>
                                                            <th colSpan="2">stock Details</th>
                                                            <th className="text-end" colSpan="2">
                                                                <a href="#" className="theme-color">Edit Info</a>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr className="table-order">
                                                            <td>
                                                                <SafeImage
                                                                    src={stock.image}
                                                                    className="img-fluid blur-up lazyload"
                                                                    alt={stock.name}
                                                                    style={{ width: 80, borderRadius: "50%" }}
                                                                />
                                                            </td>
                                                            <td>
                                                                <p>Name</p>
                                                                <h5>{stock.name}</h5>
                                                            </td>
                                                            <td>
                                                                <p>Company</p>
                                                                <h5>{stock.company}</h5>
                                                            </td>
                                                            <td>
                                                                <p>Status</p>
                                                                <h5 className="theme-color">Active</h5>
                                                            </td>
                                                        </tr>
                                                        <tr className="table-order">
                                                            <td>
                                                                <p>Phone</p>
                                                                <h5>{stock.phone}</h5>
                                                            </td>
                                                            <td>
                                                                <p>Email</p>
                                                                <h5>{stock.email}</h5>
                                                            </td>
                                                            <td colSpan="2"></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className="col-xl-4">
                                            <div className="order-success">
                                                <div className="row g-4">
                                                    <div>
                                                        <h4>Summary</h4>
                                                        <ul className="order-details">
                                                            <li>Name: {stock.name}</li>
                                                            <li>Company: {stock.company}</li>
                                                            <li>Phone: {stock.phone}</li>
                                                            <li>Email: {stock.email}</li>
                                                        </ul>
                                                        <div className="payment-mode">
                                                            <h4>Payment Method</h4>
                                                            <p>Bank Transfer</p>
                                                        </div>
                                                        <div className="delivery-sec">
                                                            <h3>Last Transaction: <span>June 5, 2024</span></h3>
                                                            <a href="#">View Transaction History</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* section end */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* stock Info Card End */}
            </div>
        </>
    );
}
